import { Controller } from '@hotwired/stimulus'

const NAV_COLLAPSED_CLASS = 'page__nav--collapsed'

export default class extends Controller {
  static targets = ['nav']


  toggleNav() {
    this.navTarget.classList.toggle(NAV_COLLAPSED_CLASS)
  }

  closeNav() {
    this.navTarget.classList.add(NAV_COLLAPSED_CLASS)
  }

  goBack(event) {
    if (history.length === 2 && event.params.backupUrl) {
      console.log('root_controller#goBack: Tubro.visit: ', event.params.backupUrl)
      Turbo.visit(event.params.backupUrl)
    } else {
      console.log('root_controller#goBack: history.back()')
      history.back()
    }
  }

  handlePerPage(event) {
    const url = new URL(window.location.href)
    url.searchParams.set('per_page', event.target.value)
    url.searchParams.delete('page')
    Turbo.visit(url.toString())
  }
}
